import { useTranslation } from 'react-i18next';
import ModalContent from '../ModalContent';
import IcCirclePartial from '@/assets/icons/CirclePartial.svg?react';
import styles from './SuspenseFallback.module.scss';

const SuspenseFallback = () => {
  const { t } = useTranslation(['common']);

  return (
    <ModalContent
      Icon={IcCirclePartial}
      loading
      title={t('common:suspense.modal.title')}
    >
      <div className={styles.detailDescription}>
        {t('common:suspense.modal.description')}
      </div>
    </ModalContent>
  );
};

export default SuspenseFallback;
